// Detects "installed as an app" (Add to Home Screen / desktop install),
// as opposed to a regular browser tab -- Chrome/Android and other engines
// report this via the `display-mode` media feature, iOS Safari exposes it
// as `navigator.standalone` instead.
export function isStandalonePwa() {
  if (typeof window === 'undefined') return false;
  const viaMediaQuery = !!(window.matchMedia && window.matchMedia('(display-mode: standalone)').matches);
  const viaIosSafari = window.navigator && window.navigator.standalone === true;
  return viaMediaQuery || viaIosSafari;
}
